import { Stack, Typography } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../routing/ProtectedRoute";
import { startCase } from "lodash";
import { ReactNode } from "react";
import { BreadcrumbsContainer, BreadcrumbsContextProvider } from "@components/custom-components/breadcrumbs/BreadcrumbsContext";
import ErrorBoundary from "../../common/ErrorBoundary";

const AdminLayout = ({ children }: { children?: ReactNode }) => {
  const { pathname } = useLocation();
  const locations = pathname?.split("/");

  return (
    <ProtectedRoute>
      <BreadcrumbsContextProvider>
        <Stack p={3}>

          <BreadcrumbsContainer>
            {locations?.slice(2).map((l, index) => (
              <Link key={index} color="inherit" to={`/${locations?.slice(1, index + 3).join("/")}`}>
                <Typography variant="breadcrumbs">
                  {startCase(l === "dashboard" ? `Dashboard` : l)}
                </Typography>
              </Link>
            ))}
          </BreadcrumbsContainer>

          <ErrorBoundary resetKey={pathname}>
            {children}
            <Outlet />
          </ErrorBoundary>
        </Stack>
      </BreadcrumbsContextProvider>
    </ProtectedRoute>
  );
};

export default AdminLayout;
